// @ts-nocheck
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import React, { Fragment, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/ErrorMessage';
import SuccessMessage from '../../components/SuccessMessage';
import { URL } from '../../service/Service';
import mbWayLogo from './mbw.png';
import multibancoLogo from './mb.png';
import creditCardLogo from './ccc.png';
import directDebitLogo from './cc.png';
import paysafecardLogo from './paysafecard.png';
import paysafecashLogo from './paysafecash.png';
import santanderLogo from './santander.png';

const serviceOptions = [
   {
      value: 'PS',
      label: 'Payshop',
      description: 'Pagamento através da rede Payshop.',
      shortLabel: 'PS',
   },
   {
      value: 'MB',
      label: 'Multibanco',
      description: 'Pagamento por referência Multibanco.',
      image: multibancoLogo,
      shortLabel: 'MB',
   },
   {
      value: 'MBW',
      label: 'MB Way',
      description: 'Pagamento rápido por telemóvel.',
      image: mbWayLogo,
      shortLabel: 'MB',
   },
   {
      value: 'CC',
      label: 'Cartão de Crédito',
      description: 'Pagamento por cartão Visa ou Mastercard.',
      image: creditCardLogo,
      shortLabel: 'CC',
   },
   {
      value: 'TPA',
      label: 'TPA',
      description: 'Pagamento através de terminal TPA.',
      shortLabel: 'TPA',
   },
   {
      value: 'DD',
      label: 'Débito Direto',
      description: 'Cobrança através de débito direto.',
      image: directDebitLogo,
      shortLabel: 'DD',
   },
   {
      value: 'BZ',
      label: 'Bizum',
      description: 'Pagamento digital através de Bizum.',
      shortLabel: 'BZ',
   },
   {
      value: 'PF',
      label: 'Paysafecard',
      description: 'Pagamento através de Paysafecard.',
      image: paysafecardLogo,
      shortLabel: 'PF',
   },
   {
      value: 'SC',
      label: 'Santander',
      description: 'Pagamento Santander Consumer Finance.',
      image: santanderLogo,
      shortLabel: 'SC',
   },
   {
      value: 'SPMB',
      label: 'Split Payment · Multibanco',
      description: 'Split Payment com referência Multibanco.',
      image: multibancoLogo,
      shortLabel: 'SP',
      badge: 'Split',
   },
   {
      value: 'SPMBW',
      label: 'Split Payment · MB Way',
      description: 'Split Payment através de MB Way.',
      image: mbWayLogo,
      shortLabel: 'SP',
      badge: 'Split',
   },
   {
      value: 'PSC',
      label: 'Paysafecash',
      description: 'Pagamento através de Paysafecash.',
      image: paysafecashLogo,
      shortLabel: 'PSC',
   },
];

const rateTypeOptions = [
   {
      value: 'FIXED_RATE',
      label: 'Taxa Fixa',
      description: 'Valor fixo aplicado por operação.',
      symbol: '€',
   },
   {
      value: 'VARIABLE_RATE',
      label: 'Taxa Variável',
      description: 'Percentagem aplicada ao valor da operação.',
      symbol: '%',
   },
   {
      value: 'MIXED_RATE',
      label: 'Taxa Mista',
      description: 'Combinação de valor fixo e percentagem.',
      symbol: '€ + %',
   },
];

const ServiceLogo = ({ service, compact = false }) => (
   <span
      className={`relative flex shrink-0 items-center justify-center overflow-hidden border border-gray-100 bg-white shadow-sm ${
         compact ? 'h-10 w-12 rounded-xl' : 'h-11 w-14 rounded-xl'
      }`}
   >
      {service?.image ? (
         <img
            src={service.image}
            alt=""
            className="h-full w-full object-contain p-1.5"
         />
      ) : (
         <span className="text-xs font-black tracking-tight text-green-cl">
            {service?.shortLabel || '--'}
         </span>
      )}
      {service?.badge && (
         <span className="absolute bottom-0 right-0 rounded-tl-md bg-green-cl px-1.5 py-0.5 text-[8px] font-bold uppercase leading-none text-white">
            {service.badge}
         </span>
      )}
   </span>
);

const CreateRate = ({ button1, button2, onSuccess }) => {
   const [successMessage, setSuccessMessage] = useState('');
   const token = sessionStorage.getItem('jwt');
   const [messageErr, setMessageErr] = useState('');
   const [subtitleErr, setSubtitleErr] = useState('');

   const [rateData, setRateData] = useState({
      nameService: '',
      rateValue: '',
      ratePercentage: '',
      rateType: '',
   });

   const selectedService = useMemo(
      () => serviceOptions.find((service) => service.value === rateData.nameService) || null,
      [rateData.nameService]
   );

   const handleChange = (event) => {
      setRateData({
         ...rateData,
         [event.target.name]: event.target.value,
      });
   };

   const handleServiceChange = (service) => {
      setRateData((current) => ({ ...current, nameService: service.value }));
   };

   const handleRateTypeChange = (rateType) => {
      setRateData((current) => ({
         ...current,
         rateType,
         ...(rateType === 'FIXED_RATE' ? { ratePercentage: '' } : {}),
         ...(rateType === 'VARIABLE_RATE' ? { rateValue: '' } : {}),
      }));
   };

   const { id } = useParams();

   const handleSubmit = async (event) => {
      event.preventDefault();
      setSuccessMessage('');
      setMessageErr('');
      setSubtitleErr('');
      try {
         const response = await fetch(`${URL}/api/partners/${id}/rate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(rateData),
         });

         const contentType = response.headers.get('content-type') || '';
         const data = contentType.includes('application/json')
            ? await response.json()
            : await response.text();

         if (response.ok) {
            // O backend devolve diretamente a lista atualizada de taxas (HTTP 201),
            // não um objeto { success: true }. Usar response.ok evita mostrar um
            // erro falso depois de a taxa já ter sido gravada.
            setMessageErr('');
            setSubtitleErr('');
            setSuccessMessage('');
            onSuccess?.(data);
            return;
         }

         const backendMessage =
            typeof data === 'string'
               ? data
               : data?.message || data?.error;

         setMessageErr(backendMessage || 'Não foi possível criar ou atualizar a taxa.');
         setSubtitleErr('Verifique os dados e volte a tentar.');
         setSuccessMessage('');
      } catch (error) {
         setMessageErr('Não foi possível pedir o levantamento.');
         setSubtitleErr('Volte a tentar.');
         setSuccessMessage('');
         setTimeout(() => {
            clearErrorMessages();
         }, 3000);
      }
   };

   const clearErrorMessages = () => {
      setMessageErr('');
      setSubtitleErr('');
   };

   const inputClassName =
      'block min-h-[48px] w-full rounded-xl border border-gray-200 bg-white px-4 text-sm text-gray-900 shadow-sm transition placeholder:text-gray-400 focus:border-green-cl focus:outline-none focus:ring-2 focus:ring-green-100';

   return (
      <form className="space-y-6" onSubmit={handleSubmit}>
         {successMessage && <SuccessMessage message={successMessage} />}
         {messageErr && (
            <ErrorMessage
               messageErr={messageErr}
               subtitleErr={subtitleErr}
               duration={2000}
            />
         )}

         <div>
            <div className="mb-2 flex items-center justify-between gap-3">
               <label className="block text-sm font-bold text-gray-800">
                  Método de pagamento
               </label>
               <span className="text-xs font-medium text-gray-400">Obrigatório</span>
            </div>

            <Listbox value={selectedService} onChange={handleServiceChange}>
               {({ open }) => (
                  <div className="relative">
                     <Listbox.Button className="relative flex min-h-[66px] w-full items-center rounded-2xl border border-gray-200 bg-white px-3.5 pr-12 text-left shadow-sm transition hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-100">
                        {selectedService ? (
                           <>
                              <ServiceLogo service={selectedService} />
                              <span className="ml-3 min-w-0 flex-1">
                                 <span className="block truncate text-sm font-bold text-gray-900">
                                    {selectedService.label}
                                 </span>
                                 <span className="mt-0.5 block truncate text-xs text-gray-500">
                                    {selectedService.description}
                                 </span>
                              </span>
                           </>
                        ) : (
                           <>
                              <span className="flex h-11 w-14 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-sm font-black text-green-cl ring-1 ring-emerald-100">
                                 €
                              </span>
                              <span className="ml-3">
                                 <span className="block text-sm font-bold text-gray-700">
                                    Escolha o método
                                 </span>
                                 <span className="mt-0.5 block text-xs text-gray-400">
                                    Selecione o serviço a configurar
                                 </span>
                              </span>
                           </>
                        )}
                        <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
                           <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                     </Listbox.Button>

                     <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                     >
                        <Listbox.Options className="absolute z-30 mt-2 max-h-80 w-full overflow-auto rounded-2xl border border-gray-100 bg-white p-2 text-sm shadow-2xl ring-1 ring-black/5 focus:outline-none">
                           {serviceOptions.map((service) => (
                              <Listbox.Option
                                 key={service.value}
                                 value={service}
                                 className={({ active }) =>
                                    `relative flex cursor-pointer select-none items-center rounded-xl px-3 py-2.5 transition ${
                                       active ? 'bg-emerald-50' : 'bg-white'
                                    }`
                                 }
                              >
                                 {({ selected }) => (
                                    <>
                                       <ServiceLogo service={service} compact />
                                       <span className="ml-3 min-w-0 flex-1">
                                          <span
                                             className={`block truncate text-sm text-gray-900 ${
                                                selected ? 'font-extrabold' : 'font-semibold'
                                             }`}
                                          >
                                             {service.label}
                                          </span>
                                          <span className="mt-0.5 block truncate text-xs text-gray-500">
                                             {service.description}
                                          </span>
                                       </span>
                                       {selected && (
                                          <span className="ml-3 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-cl text-white">
                                             <CheckIcon className="h-4 w-4" aria-hidden="true" />
                                          </span>
                                       )}
                                    </>
                                 )}
                              </Listbox.Option>
                           ))}
                        </Listbox.Options>
                     </Transition>
                  </div>
               )}
            </Listbox>
         </div>

         <div>
            <div className="mb-3 flex items-center justify-between gap-3">
               <label className="block text-sm font-bold text-gray-800">Tipo de taxa</label>
               <span className="text-xs font-medium text-gray-400">Escolha uma opção</span>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
               {rateTypeOptions.map((type) => {
                  const selected = rateData.rateType === type.value;
                  return (
                     <button
                        key={type.value}
                        type="button"
                        onClick={() => handleRateTypeChange(type.value)}
                        className={`group relative rounded-2xl border p-4 text-left transition focus:outline-none focus:ring-2 focus:ring-green-100 ${
                           selected
                              ? 'border-green-cl bg-emerald-50/70 shadow-sm'
                              : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
                        }`}
                     >
                        <div className="flex items-start justify-between gap-3">
                           <span
                              className={`flex h-9 min-w-[36px] items-center justify-center rounded-xl px-2 text-xs font-black ${
                                 selected
                                    ? 'bg-green-cl text-white'
                                    : 'bg-gray-100 text-gray-600 group-hover:bg-white'
                              }`}
                           >
                              {type.symbol}
                           </span>
                           <span
                              className={`mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border ${
                                 selected ? 'border-green-cl bg-green-cl' : 'border-gray-300 bg-white'
                              }`}
                           >
                              {selected && <CheckIcon className="h-3.5 w-3.5 text-white" />}
                           </span>
                        </div>
                        <p className="mt-3 text-sm font-extrabold text-gray-900">{type.label}</p>
                        <p className="mt-1 text-xs leading-5 text-gray-500">{type.description}</p>
                     </button>
                  );
               })}
            </div>
         </div>

         {rateData.rateType && (
            <div className="rounded-2xl border border-gray-100 bg-gray-50/80 p-4 sm:p-5">
               <p className="mb-4 text-xs font-black uppercase tracking-[0.18em] text-green-cl">
                  Valores da comissão
               </p>

               <div className={`grid grid-cols-1 gap-4 ${rateData.rateType === 'MIXED_RATE' ? 'sm:grid-cols-2' : ''}`}>
                  {(rateData.rateType === 'FIXED_RATE' || rateData.rateType === 'MIXED_RATE') && (
                     <div>
                        <label htmlFor="rateValue" className="mb-2 block text-sm font-semibold text-gray-700">
                           Valor da taxa fixa
                        </label>
                        <div className="relative">
                           <input
                              id="rateValue"
                              name="rateValue"
                              type="number"
                              min="0"
                              step="0.01"
                              inputMode="decimal"
                              placeholder="0,00"
                              className={`${inputClassName} pr-12`}
                              value={rateData.rateValue}
                              onChange={handleChange}
                           />
                           <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-sm font-bold text-gray-500">
                              €
                           </span>
                        </div>
                        <p className="mt-1.5 text-xs text-gray-400">Valor fixo por operação.</p>
                     </div>
                  )}

                  {(rateData.rateType === 'VARIABLE_RATE' || rateData.rateType === 'MIXED_RATE') && (
                     <div>
                        <label htmlFor="ratePercentage" className="mb-2 block text-sm font-semibold text-gray-700">
                           Percentagem da taxa variável
                        </label>
                        <div className="relative">
                           <input
                              id="ratePercentage"
                              name="ratePercentage"
                              type="number"
                              min="0"
                              step="0.01"
                              inputMode="decimal"
                              placeholder="0,00"
                              className={`${inputClassName} pr-12`}
                              value={rateData.ratePercentage}
                              onChange={handleChange}
                           />
                           <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-sm font-bold text-gray-500">
                              %
                           </span>
                        </div>
                        <p className="mt-1.5 text-xs text-gray-400">Percentagem aplicada à operação.</p>
                     </div>
                  )}
               </div>
            </div>
         )}

         <div className="flex flex-col-reverse gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:justify-end">
            {button2}
            {button1}
         </div>
      </form>
   );
};

export default CreateRate;
